import PropTypes from 'prop-types';
import InputAdornment from '@material-ui/core/InputAdornment';
import CountryMenu from '@cont/Login/CountryMenu';
import Field from '@base/Form/Field';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsLoggedIn } from '@api/selectors/auth';
import { VALIDATIONS } from '../constants';
import {
  FormContainer,
  StyledTextField,
  FormSectionHeading,
  FieldWrapper,
  Error,
  StyledNumberField,
  ExtraFields,
  FieldItem,
  GenderDropdown,
  StyDatePicker
} from './styles';
import { isRequired, isLengthMatchError, isFutureDate } from './utils';

const renderErrorMessage = ({ message }) => {
  return <Error>{message}</Error>;
};

const genderOptions = {
  placeholder: 'Select your gender',
  options: [
    { id: '1', label: 'Male', value: 'Male' },
    {
      id: '2',
      label: 'Female',
      value: 'Female'
    },
    {
      id: '3',
      label: 'Others',
      value: 'Others'
    }
  ]
};

const PersonalDetails = ({
  registrar,
  changeCountry,
  country,
  countries,
  showExtraFields
}) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  return (
    <FormContainer>
      <FormSectionHeading>Personal details</FormSectionHeading>
      <FieldWrapper>
        <Field
          registrar={registrar}
          name="name"
          rules={[isRequired('Name is required')]}
          render={({ onChange, value, hasError }) => (
            <StyledTextField
              placeholder="Enter full name"
              value={value}
              onChange={(data) => onChange(data.target.value)}
              error={hasError}
              disabled={isLoggedIn && registrar.data?.name}
            />
          )}
          renderError={renderErrorMessage}
        />
      </FieldWrapper>
      <FieldWrapper>
        <Field
          registrar={registrar}
          name="phone"
          rules={[
            isRequired('Mobile number is required'),
            isLengthMatchError('Please enter a valid mobile number', 10)
          ]}
          render={({ onChange, value, hasError }) => (
            <StyledNumberField
              fullWidth
              startAdornment={
                <InputAdornment>
                  <CountryMenu
                    changeCountry={changeCountry}
                    country={country}
                    countries={countries}
                    disabled={isLoggedIn}
                  />
                </InputAdornment>
              }
              placeholder="Enter your mobile number"
              onChange={(_, data) => onChange(data)}
              value={value}
              inputProps={{
                type: 'tel',
                maxLength: 10,
                required: true
              }}
              type="tel"
              error={hasError}
              disabled={isLoggedIn}
            />
          )}
          renderError={renderErrorMessage}
        />
      </FieldWrapper>
      {showExtraFields && (
        <ExtraFields>
          <FieldItem>
            <FieldWrapper>
              <Field
                registrar={registrar}
                name="dob"
                rules={[
                  isRequired('Date of birth is required'),
                  isFutureDate('Date of birth cannot be of a future date')
                ]}
                render={({ onChange, value, hasError }) => (
                  <StyDatePicker
                    variant="date"
                    width="100%"
                    value={value}
                    onChange={onChange}
                    error={hasError}
                    maxDate={VALIDATIONS.maxDOB}
                    hideDateIfEmpty
                    placeHolder="Select date of birth"
                  />
                )}
                renderError={renderErrorMessage}
              />
            </FieldWrapper>
          </FieldItem>
          <FieldItem>
            <FieldWrapper>
              <Field
                registrar={registrar}
                name="gender"
                rules={[isRequired('Gender is required')]}
                render={({ onChange, value }) => (
                  <GenderDropdown
                    options={genderOptions.options}
                    placeholder={genderOptions.placeholder}
                    selectedOption={value}
                    onOptionClick={(data) => onChange(data)}
                    buttonWidth="100%"
                  />
                )}
                renderError={renderErrorMessage}
              />
            </FieldWrapper>
          </FieldItem>
        </ExtraFields>
      )}
    </FormContainer>
  );
};

PersonalDetails.propTypes = {
  registrar: PropTypes.objectOf(PropTypes.any).isRequired,
  changeCountry: PropTypes.func.isRequired,
  country: PropTypes.objectOf(PropTypes.any).isRequired,
  countries: PropTypes.arrayOf(PropTypes.any).isRequired
};

export default PersonalDetails;
